export default "__VITE_ASSET__Dj4r$WZH__"